import { LCD } from "./LCD.js";
import { Keypad } from "./Keypad.js";

interface Props {
  revealed: string;
  position: number;
  status: "idle" | "active" | "cashed_out" | "busted";
  dangerDigits: Set<number>;
  flashDigit: { digit: number; tone: "safe" | "bust" } | null;
  shaking: boolean;
  onPress: (digit: number) => void;
}

export function Bomb({
  revealed,
  position,
  status,
  dangerDigits,
  flashDigit,
  shaking,
  onPress,
}: Props) {
  const disabled = status !== "active";
  return (
    <div className={`bomb-root ${shaking ? "shake" : ""}`}>
      {/* cluttered wire harness over the top */}
      <svg
        viewBox="0 0 360 64"
        preserveAspectRatio="none"
        className="bomb-wires-top"
      >
        <path
          d="M30 64 C 40 20, 80 44, 140 20 S 260 44, 340 12"
          className="wire wire-red"
        />
        <path
          d="M50 64 C 100 28, 160 54, 220 28 S 310 50, 350 24"
          className="wire wire-yellow"
        />
        <path
          d="M70 64 C 130 30, 200 58, 260 34 S 320 60, 355 40"
          className="wire wire-black"
        />
        <path
          d="M90 64 C 150 40, 210 58, 270 42 S 330 62, 345 52"
          className="wire wire-blue"
        />
      </svg>

      <div className="bomb-body">
        {/* C4 putty brick background layer */}
        <div className="bomb-c4" />

        {/* top canvas strap */}
        <div className="bomb-strap top">
          <span className="strap-tag">72 VIRGINS PLZ</span>
          <span className="strap-tag">1.25lb M112</span>
        </div>

        {/* electronics module (LCD + PCB + keypad) */}
        <div className="bomb-module">
          {/* LCD row with PCB sliver + battery */}
          <div className="module-lcd-row">
            <div className="pcb-strip left">
              <div className="pcb-trace" />
              <div className="pcb-trace" />
              <div className="pcb-cap" />
              <div className="pcb-cap" />
            </div>
            <LCD revealed={revealed} position={position} status={status} />
            <div className="battery">
              <span>+</span>
              <span>−</span>
            </div>
          </div>

          {/* LED bar + wires progress */}
          <div className="module-led-row">
            <div className={`led red ${status === "busted" ? "on" : ""}`} />
            <div className={`led green ${status === "cashed_out" ? "on" : ""}`} />
            <div className="wire-progress">
              <div
                className="wire-progress-fill"
                style={{ width: `${(revealed.length / 7) * 100}%` }}
              />
            </div>
            <span className="wire-progress-label">
              {revealed.length}/7
            </span>
          </div>

          {/* keypad */}
          <Keypad
            onPress={onPress}
            disabled={disabled}
            dangerDigits={dangerDigits}
            flashDigit={flashDigit}
          />
        </div>

        {/* bottom canvas strap */}
        <div className="bomb-strap bottom">
          <span className="strap-tag">IM12 EQUIV</span>
          <span className="strap-tag">EXPLOSIVE</span>
        </div>
      </div>
    </div>
  );
}
